import { createContext, useContext } from 'react';

import type { AppConfiguration } from '~/models/AppConfiguration';

export const configurationContext = createContext<AppConfiguration>({
  translatedMessages: {},
});

export const ConfigurationProvider = configurationContext.Provider;

export const useConfiguration = () => useContext(configurationContext);
